import { render, staticRenderFns } from "./PrincipalOverrideTable.vue?vue&type=template&id=806aaf04&scoped=true"
import script from "./PrincipalOverrideTable.vue?vue&type=script&lang=js"
export * from "./PrincipalOverrideTable.vue?vue&type=script&lang=js"
import style0 from "./PrincipalOverrideTable.vue?vue&type=style&index=0&id=806aaf04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806aaf04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('806aaf04')) {
      api.createRecord('806aaf04', component.options)
    } else {
      api.reload('806aaf04', component.options)
    }
    module.hot.accept("./PrincipalOverrideTable.vue?vue&type=template&id=806aaf04&scoped=true", function () {
      api.rerender('806aaf04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/PrincipalOverrideTable.vue"
export default component.exports